import { render, staticRenderFns } from "./other-icon.vue?vue&type=template&id=7a73a198"
import script from "./other-icon.vue?vue&type=script&lang=js"
export * from "./other-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports